import classNames from 'classnames/bind'

import styles from './topbar-skeleton.module.scss'

const cx = classNames.bind(styles)

// Values copied-and-pasted from `ui-topbar` at:
// https://github.com/jusbrasil/ui-topbar/blob/075ad046bc1b6641200e3de7909c7587e64cf248/src/views/index.njk#L13-L23
// See ref.: https://github.com/jusbrasil/web/pull/527
const criticalAntiCLSStyles = {
  hide: 'body { padding-top: 56px !important; } @media (min-width: 992px) { body { padding-top: 64px !important; } }',
  notHide:
    'body { padding-top: 105px !important; } @media (min-width: 992px) { body { padding-top: 113px !important; } }',
}

export function TopbarSkeleton({ hideNavbar = false }: { hideNavbar?: boolean }) {
  const className = cx('TopbarSkeleton', { 'TopbarSkeleton--hideNavbar': hideNavbar })
  return (
    <div className={className}>
      <style>{criticalAntiCLSStyles[hideNavbar ? 'hide' : 'notHide']}</style>
      <svg
        className={className}
        role="img"
        width="100%"
        height="100%"
        aria-labelledby="loading-aria"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <title id="loading-aria">Carregando barra de navegação do Jusbrasil...</title>
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          clipPath="url(#clip-path)"
          style={{ fill: 'url("#fill")' }}
        />
        <defs>
          <clipPath id="clip-path">
            <rect x="0" y="0" width="100%" height="100%" />
          </clipPath>
          <linearGradient id="fill">
            <stop offset="0.1" stopColor="#ffffff" stopOpacity="1">
              <animate
                attributeName="offset"
                values="-2; -2; 1"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="1.1" stopColor="#fafafa" stopOpacity="1">
              <animate
                attributeName="offset"
                values="-1; -1; 2"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="2.1" stopColor="#ffffff" stopOpacity="1">
              <animate
                attributeName="offset"
                values="0; 0; 3"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}
